/**
 * /library — Riwayat archive.
 *
 * The bottom-nav item is the archive entry point. Keep /library/riwayat as a
 * compatible deep link while both routes render the same screen.
 */

export { default } from './riwayat';
